import mutations from "./mutations";
import actions from "./actions";

const state = {
  facility_pricing_parameters: [],
  deleted_facility_pricing_parameter: [],
  priced_facility_parameter: []
};

export default {
  state,
  mutations,
  actions
};
